class ValorCuotaReadDto {
  public id: number;
  private _fecha: string;
  public get fecha(): string {
    return this._fecha;
  }
  public set fecha(value: string) {
    const newDate = new Date(value);
    this._fecha = newDate.toLocaleDateString("en-CA");
  }

  public valorCuota: number;
  public fundTitle: string;
  public fundId: number;
}

export default ValorCuotaReadDto;
